export enum ColorEnums {
  Primary = '#095060',
  Destructive = '#B51D1D',
  Secondary = '#095060',
  Warning = '#ea9327',
  Disable = '#8D949A',
  Gray = '#666666',
}

export enum HoverColorEnums {
  Primary = '#0094AD',
  Destructive = '#e43838',
  Secondary = '#0094AD',
  Warning = '#eca042',
  Disable = '#8D949A',
}
